module.exports = __webpack_public_path__ + "img/LM_logo.01d5ae6a.png";